<div class="card">
  <div class="card-header d-flex justify-content-between align-items-center">
    {{ header }}

    <div class="buttons d-flex align-items-center">
      <div
        *ngIf="
          showUsageButton &&
          (model.itemType === EquipmentItemType.TELESCOPE ||
            model.itemType === EquipmentItemType.CAMERA ||
            model.itemType === EquipmentItemType.SENSOR)
        "
        class="usage-menu me-2 mb-0"
        ngbDropdown
      >
        <button id="usage-menu" class="btn btn-xs btn-outline-secondary mb-0" ngbDropdownToggle type="button">
          {{ "Usage" | translate }}
        </button>

        <div [attr.aria-labelledby]="'sort-search-results'" ngbDropdownMenu>
          <button (click)="setUsageType(null)" ngbDropdownItem>
            <fa-icon *ngIf="!model.usageType; else notSelected" icon="check"></fa-icon>
            {{ "Any" | translate }}
          </button>

          <button (click)="setUsageType(EquipmentItemUsageType.IMAGING)" ngbDropdownItem>
            <fa-icon
              *ngIf="model.usageType === EquipmentItemUsageType.IMAGING; else notSelected"
              icon="check"
            ></fa-icon>
            {{ "Imaging" | translate }}
          </button>

          <button (click)="setUsageType(EquipmentItemUsageType.GUIDING)" ngbDropdownItem>
            <fa-icon
              *ngIf="model.usageType === EquipmentItemUsageType.GUIDING; else notSelected"
              icon="check"
            ></fa-icon>
            {{ "Guiding" | translate }}
          </button>
        </div>
      </div>

      <div *ngIf="showSortButton" class="sort-menu me-2 mb-0" ngbDropdown>
        <button id="sort-search-results" class="btn btn-xs btn-outline-secondary mb-0" ngbDropdownToggle type="button">
          {{ "Sort" | translate }}
        </button>

        <div [attr.aria-labelledby]="'sort-search-results'" ngbDropdownMenu>
          <button (click)="sortBy('-likes')" ngbDropdownItem>
            <fa-icon *ngIf="model.ordering === '-likes'; else notSelected" icon="check"></fa-icon>
            {{ "Most liked" | translate }}
          </button>

          <button (click)="sortBy('-published')" ngbDropdownItem>
            <fa-icon *ngIf="model.ordering === '-published'; else notSelected" icon="check"></fa-icon>
            {{ "Most recent" | translate }}
          </button>
        </div>
      </div>

      <a
        *ngIf="showMoreButton"
        [href]="searchUrl"
        (click)="onMoreClicked($event)"
        class="btn btn-xs btn-outline-primary float-end"
        astrobinEventPreventDefault
        astrobinEventStopPropagation
      >
        {{ "More" | translate }}
      </a>
    </div>
  </div>

  <div class="card-body">
    <astrobin-image-search
      #imageSearchComponent
      [loadMoreOnScroll]="loadMoreOnScroll"
      [model]="model"
      [showMarketplaceItems]="showMarketplaceItems"
      [showRetailers]="showRetailers"
      [showStaticOverlay]="showStaticOverlay"
    ></astrobin-image-search>
  </div>
</div>

<ng-template #notSelected>
  <span class="not-selected"></span>
</ng-template>
